import { cn } from '../lib/utils';

type SkeletonProps = {
    className?: string;
    variant?: 'text' | 'circular' | 'rectangular';
};

export function Skeleton({ className, variant = 'rectangular' }: SkeletonProps) {
    const baseClasses = 'animate-pulse bg-muted';
    const variantClasses = {
        text: 'h-4 rounded',
        circular: 'rounded-full',
        rectangular: 'rounded-md',
    };

    return (
        <div
            className={cn(baseClasses, variantClasses[variant], className)}
            aria-hidden="true"
        />
    );
}

export function SkeletonCard() {
    return (
        <div className="rounded-[16px] border border-border bg-card p-4 animate-pulse">
            <div className="h-4 bg-muted rounded w-1/4 mb-3" />
            <div className="h-8 bg-muted rounded w-1/3 mb-3" />
            <div className="h-12 bg-muted rounded w-full" />
        </div>
    );
}

